import React, { useState } from "react";
import { History, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import HoverVideo from "@/components/HoverVideo";
import { api, errMsg, mediaUrl } from "@/lib/api";

// Pick a previously generated AlphaGen matte from history and use it as the Luma Mask.
export default function MaskHistoryPicker({ items = [], onPick }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(null);
  const mattes = items.filter((g) => g.model_id === "bfx-alphagen" && g.status === "succeeded" && g.output_urls?.length
    && !/image/.test((g.output_types || [])[0] || ""));
  const pick = async (g) => {
    setBusy(g.id);
    try {
      const { data } = await api.post("/references/from-generation", { generation_id: g.id, index: 0, name: `alpha_matte_${g.id.slice(0, 6)}.mp4` });
      await onPick(data);
      setOpen(false);
      toast.success("Alpha matte attached to Luma Mask");
    } catch (e) { toast.error(errMsg(e, "Could not use this matte")); } finally { setBusy(null); }
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="cp-mask-history" className="text-xs text-[#64b7f6] hover:text-white flex items-center gap-1.5"><History className="w-3.5 h-3.5" />Choose from history · {mattes.length}</button>
      </PopoverTrigger>
      <PopoverContent side="right" align="start" sideOffset={44} className="w-[420px] p-2 bg-[#070B14] border-[#1065c0]/50 text-zinc-100" data-testid="cp-mask-history-list">
        {!mattes.length ? <p className="text-xs text-zinc-400 p-3">No AlphaGen mattes in this project yet.</p> : (
          <div className="grid grid-cols-2 gap-2 max-h-[420px] overflow-y-auto">
            {mattes.map((g) => (
              <button key={g.id} type="button" onClick={() => pick(g)} disabled={!!busy} data-testid={`cp-mask-history-${g.id}`}
                className="relative text-left rounded-lg overflow-hidden border border-zinc-800 hover:border-[#1e97f3] bg-black">
                <div className="aspect-video"><HoverVideo src={mediaUrl(g.output_urls[0])} poster={1} className="w-full h-full object-cover" /></div>
                <div className="p-1.5 text-[10px] text-zinc-400 truncate">{g.prompt || "AlphaGen matte"}</div>
                {busy === g.id && <div className="absolute inset-0 bg-black/60 flex items-center justify-center"><Loader2 className="w-5 h-5 animate-spin" /></div>}
              </button>
            ))}
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
